import { Typography } from "antd";
import Card from "./Card";

interface StatCardProps {
  title: string;
  value: string;
  helper?: string;
}

const StatCard = ({ title, value, helper }: StatCardProps) => (
  <Card className="stat-card">
    <Typography.Text className="stat-card__title">{title}</Typography.Text>
    <Typography.Title level={3} className="stat-card__value">
      {value}
    </Typography.Title>
    {helper ? (
      <Typography.Text className="stat-card__helper">{helper}</Typography.Text>
    ) : null}
  </Card>
);

export default StatCard;
